import React from 'react';

import { HOSPITAL_NAME } from '../../../../shared/env';

import { HealthHubLogo, HospitalNameLogo } from './styledComponents';

export const HospitalLogo = () =>
  HOSPITAL_NAME ? (
    <HospitalNameLogo>{HOSPITAL_NAME}</HospitalNameLogo>
  ) : (
    <HealthHubLogo />
  );
